import React from 'react';
import { X, AlertTriangle, CheckCircle, Loader } from 'lucide-react';

interface EvaluationResult {
  name: string;
  status: string;
  unfulfilledCompulsory: string[];
  unfulfilledOptional: string[];
}

interface CreditEvaluationPopupProps {
  results: EvaluationResult[] | null;
  onClose: () => void;
}

const CreditEvaluationPopup: React.FC<CreditEvaluationPopupProps> = ({ results, onClose }) => {
  const isLoading = results === null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center overflow-auto">
      <div className="bg-neutral-900 rounded-lg w-full max-w-5xl p-6 shadow-lg text-white relative min-h-[300px]">
        <button className="absolute top-4 right-4 text-gray-400 hover:text-white" onClick={onClose}>
          <X className="w-5 h-5" />
        </button>
        <h2 className="text-lg font-semibold mb-4">Output</h2>

        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <Loader className="w-8 h-8 animate-spin text-gray-400" />
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[70vh] overflow-auto pr-2">
            {results!.map((item, idx) => (
              <div key={idx} className="border border-neutral-700 rounded-md p-4 bg-neutral-800">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-medium">{item.name}</h3>
                  <span className={`text-sm font-bold ${item.status === 'Not Eligible' ? 'text-red-400' : 'text-green-400'}`}>
                    {item.status}
                  </span>
                </div>
                <div className="text-sm">
                  {item.unfulfilledCompulsory?.length > 0 && (
                    <div className="mt-2">
                      <div className="text-yellow-400 flex items-center gap-1"><AlertTriangle className="w-4 h-4" /> Unfulfilled Compulsory</div>
                      <ul className="list-disc ml-5 mt-1 text-gray-300">
                        {item.unfulfilledCompulsory.map((c, i) => <li key={i}>{c}</li>)}
                      </ul>
                    </div>
                  )}
                  {item.unfulfilledOptional?.length > 0 && (
                    <div className="mt-2">
                      <div className="text-gray-400 flex items-center gap-1"><CheckCircle className="w-4 h-4" /> Unfulfilled Optional</div>
                      <ul className="list-disc ml-5 mt-1 text-gray-400">
                        {item.unfulfilledOptional.map((c, i) => <li key={i}>{c}</li>)}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CreditEvaluationPopup;
